import React from "react";
import { assets } from "../../../Assets/assets";
import LabelHeading from "../../common/LabelHeading";

const Approach = ({ id }) => {
  const approachList = [
    {
      icon: assets.approachicon1,
      title: "Client-centric and candidate-driven approach:",
      text: "We prioritize our clients’ needs and goals while also focusing on the growth and satisfaction of our candidates, fostering a win-win environment for all parties involved.",
    },
    {
      icon: assets.approachicon2,
      title: "Time-sensitive and quality-oriented delivery:",
      text: "We understand the importance of timely delivery without compromising on the quality of our services. Our processes ensure efficient talent acquisition.",
    },
    {
      icon: assets.approachicon3,
      title: "Result-oriented recruitment advisors:",
      text: "They work closely with clients to understand their requirements and deliver successful staffing solutions tailored to their specific needs.",
    },
  ];

  return (
    <section id={id} className="w-full bg-white">
      <div className="max-w-[1400px] mx-auto px-6 xl:py-20 py-14 space-y-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
          <div data-aos="fade-up-right" data-aos-duration="1000">
            <LabelHeading
              label="Approach"
              heading="Our Approach in Brief"
              position="left"
            // text={"We prioritize our clients’ needs and goals while also focusing on the growth and satisfaction of our candidates, fostering a win-win environment for all parties involved."}
            />
            <p data-aos="fade-up" data-aos-duration="1000" className="text-secondaryTextColor py-2 max-w-[580px] text-[15px] font-DmSans leading-relaxed">
              We prioritize our clients’ needs and goals while also focusing on the
              growth and satisfaction of our candidates, fostering a win-win
              environment for all parties involved.
            </p>

            <img data-aos="fade-up" data-aos-duration="1000"
              src={assets.approachimg}
              alt="Approach"
              className="rounded-xl w-full h-[340px] md:h-[22rem] object-cover shadow-sm"
            />
          </div>

          <div className="space-y-5">
            {approachList.map(({ icon, title, text }, i) => (
              <div data-aos="fade-up" data-aos-duration="1000" data-aos-delay={i * 100}
                key={i}
                className="border rounded-xl p-4 xl:p-8 shadow-sm hover:shadow-md transition-all bg-white cursor-default flex gap-5"
              >
                <div className="min-w-[50px] h-[50px] bg-[#EEF6FF] rounded-xl flex justify-center items-center">
                  <img src={icon} alt="icon" className="w-7 h-7 object-contain" />
                </div>

                <div>
                  <h4 className="font-semibold text-primaryNavyTextColor text-xl mb-1">
                    {title}
                  </h4>
                  <p className="text-secondaryTextColor text-[14px] leading-relaxed font-DmSans">
                    {text}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default Approach;
